import { sb } from '../../../supabase.ts';
import { escapeHtml } from '../../../main.ts';

export async function renderOtherSchoolResultListPage(app: HTMLElement): Promise<void> {
  const tableNameExam = 'exam_others_school';
  let students: any[] = [];
  let filteredStudents: any[] = [];

  app.innerHTML = `
    <style>
      .rl-wrap {
        background: radial-gradient(circle at 50% 50%, rgba(16, 185, 129, 0.04), transparent 45%), linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
        color: #334155;
        font-family: 'Outfit', 'Segoe UI', sans-serif;
        min-height: 100vh;
        padding-bottom: 60px;
      }
      .rl-header {
        background: rgba(255, 255, 255, 0.9);
        backdrop-filter: blur(8px);
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        padding: 14px 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .rl-header h1 {
        font-size: 20px;
        margin: 0;
        font-weight: 850;
        color: #0f172a;
      }
      .back-btn {
        color: #10b981;
        text-decoration: none;
        margin-right: 12px;
        font-size: 20px;
        font-weight: bold;
        transition: transform 0.2s;
        display: inline-block;
      }
      .back-btn:hover {
        transform: translateX(-3px);
      }
      .rl-container {
        padding: 24px;
        max-width: 1000px;
        margin: 0 auto;
      }
      .card-section {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        padding: 20px;
        margin-bottom: 24px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
      }
      .filter-row {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        align-items: center;
        margin-bottom: 16px;
      }
      input[type=text], select {
        padding: 10px 14px;
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 6px;
        font-size: 14px;
        color: #0f172a;
        outline: none;
        transition: border-color 0.2s, box-shadow 0.2s;
      }
      input:focus, select:focus {
        border-color: #10b981;
        box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.15);
      }
      .search-box {
        flex: 1;
        min-width: 250px;
      }
      .filter-select {
        width: 160px;
      }
      .student-table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 16px;
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.06);
        border-radius: 8px;
        overflow: hidden;
      }
      .student-table th, .student-table td {
        padding: 12px 16px;
        text-align: left;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
      }
      .student-table th {
        background: #f8fafc;
        font-weight: 700;
        font-size: 12px;
        color: #64748b;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
      .student-table tr:hover td {
        background: rgba(0, 0, 0, 0.01);
      }
      .btn {
        padding: 6px 12px;
        font-size: 13px;
        border-radius: 4px;
        font-weight: 600;
        cursor: pointer;
        border: none;
        transition: opacity 0.2s;
        color: #0f172a;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        gap: 4px;
      }
      .btn.primary {
        background: #10b981;
      }
      .btn.secondary {
        background: rgba(0, 0, 0, 0.1);
        border: 1px solid rgba(0, 0, 0, 0.15);
        color: #334155;
      }
      .btn.danger {
        background: #ef4444;
      }
      .approval-badge {
        padding: 4px 8px;
        border-radius: 12px;
        font-size: 11px;
        font-weight: 700;
        cursor: pointer;
        border: none;
        transition: opacity 0.2s;
      }
      .approval-badge.approved {
        background: rgba(16, 185, 129, 0.15);
        color: #10b981;
        border: 1px solid rgba(16, 185, 129, 0.3);
      }
      .approval-badge.pending {
        background: rgba(245, 158, 11, 0.15);
        color: #f59e0b;
        border: 1px solid rgba(245, 158, 11, 0.3);
      }
      .status-banner {
        text-align: center;
        padding: 30px;
        color: #64748b;
      }
    </style>

    <div class="rl-wrap">
      <header class="rl-header">
        <div style="display: flex; align-items: center;">
          <a href="/other_school_dashboard" class="back-btn">⬅</a>
          <h1>📋 Compiled Results — General (Class 1-8)</h1>
        </div>
      </header>

      <div class="rl-container">
        <div class="card-section">
          <div class="filter-row">
            <input type="text" id="searchBox" class="search-box" placeholder="🔍 Search student name, roll, IID..." />
            
            <select id="classFilter" class="filter-select">
              <option value="">All Classes</option>
            </select>

            <select id="sectionFilter" class="filter-select">
              <option value="">All Sections</option>
            </select>
          </div>

          <div id="loadingBanner" class="status-banner">
            🔄 Loading compiled exam results from database...
          </div>

          <div id="resultsTableWrapper" style="display: none; overflow-x: auto;">
            <table class="student-table">
              <thead>
                <tr>
                  <th>Roll</th>
                  <th>IID</th>
                  <th>Student Name</th>
                  <th>Class</th>
                  <th>Section</th>
                  <th>Total</th>
                  <th>GPA</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody id="studentTableBody"></tbody>
            </table>
          </div>

          <div id="emptyBanner" class="status-banner" style="display: none;">
            ⚠️ No matching student records found.
          </div>

          <div id="summaryFooter" style="margin-top: 16px; font-size: 13.5px; color: #64748b; text-align: right;"></div>
        </div>
      </div>
    </div>
  `;

  // Fetch DOM elements
  const searchBox = document.getElementById('searchBox') as HTMLInputElement;
  const classFilter = document.getElementById('classFilter') as HTMLSelectElement;
  const sectionFilter = document.getElementById('sectionFilter') as HTMLSelectElement;
  const loadingBanner = document.getElementById('loadingBanner') as HTMLDivElement;
  const resultsTableWrapper = document.getElementById('resultsTableWrapper') as HTMLDivElement;
  const studentTableBody = document.getElementById('studentTableBody') as HTMLTableSectionElement;
  const emptyBanner = document.getElementById('emptyBanner') as HTMLDivElement;
  const summaryFooter = document.getElementById('summaryFooter') as HTMLDivElement;

  async function loadData() {
    try {
      const { data, error } = await sb.from(tableNameExam).select('*');
      if (error) throw error;

      students = data || [];
      filteredStudents = [...students];

      populateFilters();
      renderTable();
    } catch (e: any) {
      loadingBanner.textContent = '❌ Failed to load exam results: ' + e.message;
      loadingBanner.style.color = '#ef4444';
    }
  }

  function populateFilters() {
    const classes = Array.from(new Set(students.map(s => s.class_2025).filter(Boolean))).sort();
    const sections = Array.from(new Set(students.map(s => s.section_2025).filter(Boolean))).sort();

    classes.forEach(c => {
      const opt = document.createElement('option');
      opt.value = c;
      opt.textContent = c;
      classFilter.appendChild(opt);
    });

    sections.forEach(s => {
      const opt = document.createElement('option');
      opt.value = s;
      opt.textContent = s;
      sectionFilter.appendChild(opt);
    });
  }

  function renderTable() {
    loadingBanner.style.display = 'none';
    studentTableBody.innerHTML = '';

    if (filteredStudents.length === 0) {
      resultsTableWrapper.style.display = 'none';
      emptyBanner.style.display = 'block';
      summaryFooter.textContent = '';
      return;
    }

    resultsTableWrapper.style.display = 'block';
    emptyBanner.style.display = 'none';

    filteredStudents.forEach(student => {
      const tr = document.createElement('tr');
      const isApproved = ['1', 'true', 'yes', 't'].includes(String(student.result_approval || '').toLowerCase());
      const gpaVal = student.gpa_final !== null ? parseFloat(student.gpa_final).toFixed(2) : '-';
      const totalMark = student.total_mark !== null ? parseFloat(student.total_mark).toFixed(1) : '-';

      tr.innerHTML = `
        <td style="font-weight: 700; color: #0f172a;">${student.roll_2025 || '-'}</td>
        <td>${student.iid || '-'}</td>
        <td style="font-weight: 600; color: #0f172a;">${escapeHtml(student.student_name_en || '')}</td>
        <td>${escapeHtml(student.class_2025 || '')}</td>
        <td>${escapeHtml(student.section_2025 || '')}</td>
        <td>${totalMark}</td>
        <td style="font-weight: bold; color: #10b981;">${gpaVal}</td>
        <td>
          <button class="approval-badge ${isApproved ? 'approved' : 'pending'}" data-iid="${student.iid}">
            ${isApproved ? 'Approved' : 'Pending'}
          </button>
        </td>
        <td>
          <div style="display: flex; gap: 8px;">
            <a href="/other_school/result/details?iid=${student.iid}" class="btn primary">View</a>
            <a href="/other_school/result/edit?iid=${student.iid}" class="btn secondary">Edit</a>
          </div>
        </td>
      `;

      // Set up toggle approval event listener
      const approvalBtn = tr.querySelector('.approval-badge') as HTMLButtonElement;
      approvalBtn.onclick = async (e) => {
        e.preventDefault();
        approvalBtn.disabled = true;
        const iid = approvalBtn.getAttribute('data-iid');
        const nextVal = !isApproved;

        try {
          const { error } = await sb.from(tableNameExam).update({ result_approval: nextVal }).eq('iid', iid);
          if (error) throw error;

          // Update state and refresh row
          student.result_approval = nextVal;
          renderTable();
        } catch (err: any) {
          alert('Failed to update result approval state: ' + err.message);
        } finally {
          approvalBtn.disabled = false;
        }
      };

      studentTableBody.appendChild(tr);
    });

    summaryFooter.textContent = `Showing ${filteredStudents.length} of ${students.length} student results.`;
  }

  function applyFilters() {
    const q = searchBox.value.toLowerCase().trim();
    const cls = classFilter.value;
    const sec = sectionFilter.value;

    filteredStudents = students.filter(student => {
      const matchesQ = !q || 
        String(student.student_name_en || '').toLowerCase().includes(q) ||
        String(student.iid || '').toLowerCase().includes(q) ||
        String(student.roll_2025 || '').toLowerCase().includes(q);

      const matchesCls = !cls || student.class_2025 === cls;
      const matchesSec = !sec || student.section_2025 === sec;

      return matchesQ && matchesCls && matchesSec;
    });

    // Sort by roll ascending when filtering
    filteredStudents.sort((a, b) => {
      const rollA = parseInt(a.roll_2025) || 9999;
      const rollB = parseInt(b.roll_2025) || 9999;
      return rollA - rollB;
    });

    renderTable();
  }

  searchBox.addEventListener('input', applyFilters);
  classFilter.addEventListener('change', applyFilters);
  sectionFilter.addEventListener('change', applyFilters);

  // Initial load
  await loadData();
}
